// store/slices/breadcrumbSlice.js
import { createSlice } from "@reduxjs/toolkit";

// Always read sessionStorage dynamically
const getInitialBreadcrumbs = () => {
  const storedRole = sessionStorage.getItem("userRole");

  if (storedRole && storedRole !== "undefined") {
    return [
      {
        title: "Dashboard",
        path: storedRole === "owner" ? "/seller/dashboard" : "/buyer/dashboard",
      },
    ];
  }

  return [{ title: "Home", path: "/" }];
};

const initialState = getInitialBreadcrumbs();

// Save breadcrumbs into sessionStorage
const saveBreadcrumbs = (breadcrumbs) => {
  sessionStorage.setItem("breadcrumbs", JSON.stringify(breadcrumbs));
};

const breadcrumbSlice = createSlice({
  name: "breadcrumb",
  initialState,
  reducers: {
    // Reset breadcrumb list
    resetBreadcrumbs: (state, action) => {
      const storedRole = sessionStorage.getItem("userRole");

      const newState = [
        storedRole && storedRole !== "undefined"
          ? {
              title: "Dashboard",
              path:
                storedRole === "owner"
                  ? "/seller/dashboard"
                  : "/buyer/dashboard",
            }
          : { title: "Home", path: "/" },
      ];

      const payload = action.payload;

      if (payload?.title && payload?.path) {
        newState.push(payload);
      }

      saveBreadcrumbs(newState);
      return newState;
    },

    // Add breadcrumb only if not exists
    addBreadcrumb: (state, action) => {
      const addItem = (item) => {
        const exists = state.some(
          (b) => b.title === item.title && b.path === item.path
        );
        if (!exists) state.push(item);
      };

      if (Array.isArray(action.payload)) {
        action.payload.forEach(addItem);
      } else {
        addItem(action.payload);
      }

      saveBreadcrumbs(state);
    },

    // Replace all breadcrumbs
    setBreadcrumbs: (state, action) => {
      saveBreadcrumbs(action.payload);
      return action.payload;
    },

    // Remove breadcrumbs using condition
    removeBreadCrumbsByCondition: (state, action) => {
      const condition = action.payload;

      if (typeof condition !== "function") return state;

      const filtered = state.filter((b) => !condition(b));
      saveBreadcrumbs(filtered);
      return filtered;
    },
  },
});

export const {
  resetBreadcrumbs,
  addBreadcrumb,
  setBreadcrumbs,
  removeBreadCrumbsByCondition,
} = breadcrumbSlice.actions;

export default breadcrumbSlice.reducer;
